import { RoutePath } from '@constants/routes';

export const ACCOUNT_SETTINGS_TABS = [
    {
        label: 'SettingsTabs.profile',
        value: RoutePath.AccountSettingsProfile,
    },
    {
        label: 'SettingsTabs.general',
        value: RoutePath.AccountSettingsGeneral,
    },
    {
        label: 'common.locations',
        value: RoutePath.AccountSettingsCompanies,
    },
    {
        label: 'common.brands',
        value: RoutePath.AccountSettingsBrands,
    },
    {
        label: 'SettingsTabs.channels',
        value: RoutePath.AccountSettingsChannels,
    },
    {
        label: 'common.users',
        value: RoutePath.AccountSettingsUsers,
    },
    {
        label: 'SettingsTabs.integrations',
        value: RoutePath.AccountSettingsIntegrations,
    },
];
